<template>
  <div class="wxqq_main">
    <img src="@/assets/wxqq.png" alt="">
  </div>
</template>

<script>
export default {
  name: 'WxQQWebGo'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wxqq_main {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200000;
  background: rgba(0,0,0,0.5);
}
.wxqq_main img {
  width: 100%;
}
</style>
